import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import CommonAlertPopup from "commonModule/commonAlertPopup.tsx";
import { CookiesProvider } from "react-cookie";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CookiesProvider>
    <Provider store={store}>
      <App />
      <CommonAlertPopup />
    </Provider>
  </CookiesProvider>  
);
reportWebVitals();
